import {ReactComponent as RemoteDownloadIcon} from "../../../assets/icons/remote_download.svg";
import {ReactComponent as TachoIcon} from "../../../assets/icons/tacho.svg";
import {ReactComponent as DTCOIcon} from "../../../assets/icons/dtco.svg";
import {ReactComponent as DevicesIcon} from "../../../assets/icons/devices.svg";
import {useTranslation} from "react-i18next";
import {Stack, Tooltip} from "@mui/material";
import {EMPTY_UI} from "../../../variables";
import React from "react";

export interface DeviceCapabilitiesProps {
    capabilities?: DeviceCapability[];
    deviceModel?: string;
    showEmptyUi?: boolean;
    hideGps?: boolean;
}

export enum DeviceCapability {
    GPS = "GPS",
    FMS = "FMS",
    DTCO = "DTCO",
    RDL = "RDL",
}

enum DeviceModelDSX {
    DS2 = "DS2",
    DSX = "DSX",
    DSX3 = "DSX3",
}

const DeviceCapabilities = ({
    capabilities,
    deviceModel,
    showEmptyUi = false,
    hideGps = false,
}: DeviceCapabilitiesProps): JSX.Element => {
    const {t} = useTranslation();

    let capabilitiesConfig;

    if (Object.values(DeviceModelDSX).includes(deviceModel as DeviceModelDSX)) {
        capabilitiesConfig = [
            {
                name: DeviceCapability.GPS,
                icon: <DevicesIcon fill={capabilities?.includes(DeviceCapability.GPS) ? "#323232" : "#DBDBDB"} />,
            },
            {
                name: DeviceCapability.FMS,
                icon: <TachoIcon fill={capabilities?.includes(DeviceCapability.FMS) ? "#323232" : "#DBDBDB"} />,
            },
            {
                name: DeviceCapability.DTCO,
                icon: <DTCOIcon fill={capabilities?.includes(DeviceCapability.DTCO) ? "#323232" : "#DBDBDB"} />,
            },
            {
                name: DeviceCapability.RDL,
                icon: (
                    <RemoteDownloadIcon fill={capabilities?.includes(DeviceCapability.RDL) ? "#323232" : "#DBDBDB"} />
                ),
            },
        ];
    } else {
        capabilitiesConfig = [
            {
                name: DeviceCapability.GPS,
                icon: (
                    <RemoteDownloadIcon fill={capabilities?.includes(DeviceCapability.GPS) ? "#323232" : "#DBDBDB"} />
                ),
            },
        ];
    }
    const visibleCapabilities = capabilitiesConfig.filter(
        (capability) => !hideGps || capability.name !== DeviceCapability.GPS
    );
    const renderCapability = (capability: {name: DeviceCapability; icon: React.ReactNode}) => {
        return (
            <Tooltip
                key={capability.name}
                title={
                    capabilities?.includes(capability.name)
                        ? t(`${capability.name.toLowerCase()}State_capable`)
                        : t(`${capability.name.toLowerCase()}State_notCapable`)
                }
                placement={"top"}
            >
                <span>{capability.icon}</span>
            </Tooltip>
        );
    };

    if (showEmptyUi || visibleCapabilities.length === 0) {
        return <div>{EMPTY_UI} </div>;
    }

    return (
        <Stack direction="row" spacing={1} alignItems={"center"}>
            {visibleCapabilities.map(renderCapability)}
        </Stack>
    );
};

export default DeviceCapabilities;
